import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { scroller } from 'react-scroll';

const Btn = styled.button`
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightHeavy};
  border: 0;
  background-color: ${props => props.theme.btnPrimaryBackgroundColor};
  border-radius: 4px;
  text-transform: uppercase;
  color: #fff;
  font-size: ${props => (props.theme.isPortrait ? 16 : 20)}px;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  height: 60px;
  margin-top: ${props => (props.theme.isPortrait ? 36 : 50)}px;
  margin-bottom: ${props => (props.theme.isPortrait ? 70 : 0)}px;
  max-width: 384px;
  width: ${props => (props.theme.isPortrait ? 80 : 26.7)}vw;

  &:hover {
    background-color: #9b7e32;
  }
`;

export default function Button({ text }) {
  const scrollToForm = () => scroller.scrollTo('form', {
    duration: 1500,
    smooth: 'easeInOutQuint',
  });

  return <Btn type="button" onClick={scrollToForm}>{text}</Btn>;
}

Button.propTypes = {
  text: PropTypes.string.isRequired,
};
